var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Borrowed',{attrs:{"change_resident_id":_vm.change_resident_id}}),_c('Lent',{on:{"handleToResident":_vm.handleToResident}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }